import { Button, ButtonColor, ButtonSize } from '@leland-dev/leland-ui-library';
import React from 'react';

import { type Scalars } from '../../__generated-gql-types__/globalTypes';

import type { FeaturedServicesFilterCategoryFragment } from './__generated-gql-types__/FeaturedServicesFilter.generated';

interface FeaturedServicesFilterProps {
  category: FeaturedServicesFilterCategoryFragment;
  applyFilter: (
    coachingFocusesFilter: Nullable<
      Array<Scalars['CoachingFocusUrn']['output']>
    >,
  ) => void;
}

const FeaturedServicesFilter: React.FC<FeaturedServicesFilterProps> = ({
  category,
  applyFilter,
}) => {
  const featuredServices = category.featuredFocusList;
  const comprehensiveServices = category.comprehensiveFocusList;

  return (featuredServices ?? comprehensiveServices) ? (
    <div className="mb-8 mt-6 flex flex-wrap gap-2">
      {comprehensiveServices ? (
        <Button
          buttonColor={ButtonColor.WHITE}
          onClick={() => applyFilter(comprehensiveServices.map((f) => f.id))}
          label={`Comprehensive ${category.name} Coaching`}
          size={ButtonSize.LARGE}
          id="featured_services_filter--comprehensive_coaching"
        />
      ) : null}
      {featuredServices
        ? featuredServices.map((focus) => (
            <Button
              key={focus.id}
              buttonColor={ButtonColor.WHITE}
              onClick={() => applyFilter([focus.id])}
              label={focus.name}
              size={ButtonSize.LARGE}
              id="featured_services_filter--featured_service"
            />
          ))
        : null}
    </div>
  ) : null;
};

export default FeaturedServicesFilter;
